import { PlayerType } from 'tag/ts/tag/model/type/PlayerType';
import { AviaPlugin } from 'tag/ts/tag/player/adapters/avia/plugins/AviaPlugin';
export class PlayerUIPlugin extends AviaPlugin {
    namespaceKey = 'player_ui';
    package = undefined;
    constructor(argument) {
        super({
            ...argument,
            name: 'PlayerUIPlugin'
        });
    }
    shouldBeUsed() {
        const isFullPlayer = this?.tag?.view?.playerType === PlayerType.FULL;
        const pluginExists = !this.utils.Type.isNullOrUndefined(this.loadedPlugin);
        return isFullPlayer && pluginExists;
    }
    getFactoryParams() {
        return {
            ...super.getFactoryParams(),
            posterImageUrl: this?.tag?.model?.apiMetadata?.thumbnail || undefined
        };
    }
}
